module.exports = __webpack_public_path__ + "static/media/introduce_p7@2x.26d0f2ae.png";